<input class="c-input"
  [class.c-input-error]="!isValid"
  [formControl]="inputForm"
  [placeholder]="placeholder"
  (focus)="onFocus()"
  (focusout)="onBlur()"
>